<template>
</template>

<script>
import API from '@/lib/api'
import DataSection from '@/components/DataSection'
import ListItem from '@/components/ListItem'

export default {
  name: 'NewEventStart',
  components: { DataSection, ListItem },
  data () {
    var data = {
      hasError: false,
      errorMessage: null
    }
    var version = this.$route.params.version
    if (version === '1') {
      data.originatorTeamId = parseInt(this.$route.params.originatorTeamIdEncoded, 36)
      data.workflowId = parseInt(this.$route.params.workflowIdEncoded, 36)
      data.jobNumber = this.$route.params.additionalDataEncoded
      data.trackerId = null
      data.originatorData = null
    } else if (version === '2') {
      data.originatorTeamId = parseInt(this.$route.params.originatorTeamIdEncoded, 36)
      data.workflowId = parseInt(this.$route.params.workflowIdEncoded, 36)
      data.jobNumber = null
      data.trackerId = parseInt(this.$route.params.additionalDataEncoded)
      data.originatorData = null
    } else {
      data.trackerId = this.$route.query.i != null ? parseInt(this.$route.query.i, 36) : null
      data.workflowId = this.$route.query.w != null ? parseInt(this.$route.query.w, 36) : null
      data.originatorTeamId = this.$route.query.t != null ? parseInt(this.$route.query.t, 36) : null
      data.jobNumber = this.$route.query.j
    }
    return data
  },
  watch: {
    '$route' (to, from) {
      this.updateData()
      this.start()
    }
  },
  computed: {},
  mounted () {
    this.fetchTracker()
  },
  methods: {
    updateData () {
      var version = this.$route.params.version
      if (version === '1') {
        this.originatorTeamId = parseInt(this.$route.params.originatorTeamIdEncoded, 36)
        this.workflowId = parseInt(this.$route.params.workflowIdEncoded, 36)
        this.jobNumber = this.$route.params.additionalDataEncoded
        this.trackerId = null
        this.originatorData = null
      } else if (version === '2') {
        this.originatorTeamId = parseInt(this.$route.params.originatorTeamIdEncoded, 36)
        this.workflowId = parseInt(this.$route.params.workflowIdEncoded, 36)
        this.jobNumber = null
        this.trackerId = parseInt(this.$route.params.additionalDataEncoded)
        this.originatorData = null
      } else {
        this.trackerId = this.$route.query.i != null ? parseInt(this.$route.query.i, 36) : null
        this.workflowId = this.$route.query.w != null ? parseInt(this.$route.query.w, 36) : null
        this.originatorTeamId = this.$route.query.t != null ? parseInt(this.$route.query.t, 36) : null
        this.jobNumber = this.$route.query.j
      }
    },
    fetchTracker () {
      if (this.trackerId != null && (this.jobNumber == null || this.workflowId == null || this.originatorTeamId == null)) {
        this.hasError = false
        API.get(`/trackers/${this.trackerId}`, {}, this.$store.getters.authHeaders)
          .then((response) => {
            this.workflowId = response.data.workflow_id
            this.originatorTeamId = response.data.team_id
            this.jobNumber = response.data.job_number
            this.originatorData = response.data.shipper_data
            this.start()
          })
      } else {
        this.start()
      }
    },
    start () {
      var query = {
        otid: this.originatorTeamId,
        wfid: this.workflowId,
        job: this.jobNumber,
        tid: this.trackerId,
        odata: this.originatorData
      }
      this.$router.push({ path: '/events/new/choose', query: query })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/NewEventStart.vue